<template>
  <div>
    <v-table
      :height="550"
      @on-custom-comp="customCompFunc"
      is-horizontal-resize=""
      column-width-drag
      style="width:100%;"
      :columns="tableColumn"
      :table-data="subjectKeywordData"
      row-hover-color="#edf7ff"
      :is-loading="modal_loading"
      title-bg-color="#f8f8f9"
    ></v-table>
    <!--删除模式框-->
    <Modal v-model="subjectKeywordDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#ff6600;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ keyword }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeSubjectKeyword()"
          :disabled="isDisable"
          >{{ $t("common.del") }}</Button
        >
      </div>
    </Modal>
    <!-- 编辑模式框 -->
    <Modal
      v-model="editSubjectKeywordModalVisible"
      :title="$t('common.edit')"
      @on-ok="editSubjectKeywordSubmit('editSubjectKeywordForm')"
      @on-cancel="editSubjectKeywordReset('editSubjectKeywordForm')"
      :loading="loadingEdit"
      :mask-closable="false"
      width="700px;"
      :ok-text="$t('common.submit')"
      :cancelText="$t('alarms.common.cancel')"
      :styles="{ top: '35px' }"
    >
      <Form
        ref="editTagForm"
        :model="subjectKeywordEditForm"
        :label-width="100"
      >
        <!-- ID -->
        <input type="hidden" v-model="subjectKeywordEditForm.id" />
        <!-- 公司 -->
        <FormItem
          :label="$t('configuration_management.mailbox_management.company')"
          prop="companyId"
        >
          <Select
            v-model="subjectKeywordEditForm.companyId"
            style="width:300px;"
          >
            <Option
              :value="item.id"
              v-for="(item, index) in companyIdList"
              v-bind:key="index"
              >{{ item.companyName }}</Option
            >
          </Select>
        </FormItem>
        <!-- 关键词 -->
        <FormItem
          :label="
            $t(
              'configuration_management.mailbox_management.emailSubjectKeyword'
            )
          "
          prop="keyword"
        >
          <Input
            v-model="subjectKeywordEditForm.keyword"
            style="width:300px;"
          />
        </FormItem>
      </Form>
    </Modal>
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import editSubjectKeyword from "./EditSubjectKeyword";
import Vue from "vue";

var tableSubjectKeywordVue = {};
export default {
  name: "TableSubjectKeyword",
  components: {
    editSubjectKeyword
  },
  data() {
    return {
      isShowOperationLog: false,
      val: "",
      showList: [],
      dataTotal: 0,
      showSubjectKeywordModal: false,
      lineIndex: 0,
      subjectKeywordName: "",
      isDisable: false,
      current: 1,
      pageSize: 10,
      subjectKeywordDelmodal: false,
      editSubjectKeywordModalVisible: false,
      keyword: "",
      loadingEdit: false,
      modal_loading: false,
      companyIdList: [],
      subjectKeywordEditForm: {
        id: 0,
        companyId: 0,
        keyName: ""
      },
      tableColumn: [
        {
          field: "companyName",
          title: this.$t("configuration_management.mailbox_management.company"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "keyword",
          title: this.$t(
            "configuration_management.mailbox_management.emailSubjectKeyword"
          ),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true
        },
        {
          field: "action",
          title: this.$t("common.operation"),
          width: 180,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          componentName: "subjectkeyword-button-group"
        }
      ],
      subjectKeywordData: []
    };
  },
  beforeCreate: function() {
    tableSubjectKeywordVue = this;
  },
  mounted: function() {
    tableSubjectKeywordVue.getSubjectKeywordData();
    this.listRegisterInformation();
  },
  methods: {
    // 公司列表
    listRegisterInformation: function() {
      this.$api.user.listRegisterInformation().then(res => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
      });
    },
    // 删除 编辑
    /**************************************************************/
    // 传递vue组件
    customCompFunc(params) {
      if (params.type === "delete") {
        this.lineIndex = params.index;
        this.keyword = params.rowData.keyword;
        this.subjectKeywordDelmodal = true;
      } else if (params.type === "edit") {
        this.editClick(params.index, params.rowData);
      }
    },
    //显示数据
    showAll: function() {
      tableSubjectKeywordVue.getSubjectKeywordData();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.subjectKeywordName = this.subjectKeywordData[index].name;
    },
    getSubjectKeywordData: function() {
      //获取查询内容
      eventBus.$on("subjectKeywordSearchName", function(val) {
        tableSubjectKeywordVue.val = val;
      });
      tableSubjectKeywordVue.$api.mailbox
        .pageSubjectKeyword({
          keyword: tableSubjectKeywordVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          if (res.data.records) {
            this.subjectKeywordData = JSON.parse(
              JSON.stringify(res.data.records)
            );
          }
          this.modal_loading = false;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        })
        .catch(err => {
          if (err.status == 404) {
            this.modal_loading = false;
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSubjectKeywordVue.getSubjectKeywordData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSubjectKeywordVue.getSubjectKeywordData();
    },
    // 删除
    removeSubjectKeyword: function() {
      this.isDisable = true; //开始可以点击
      const lineIndex = this.lineIndex;
      this.$api.mailbox
        .deleteSubjectKeyword("id", this.subjectKeywordData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            tableSubjectKeywordVue.getSubjectKeywordData();
            this.isDisable = false;
            this.modal_loading = false;
            this.subjectKeywordDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    editClick(rowIndex, rowData) {
      //编辑
      this.editSubjectKeywordModalVisible = true;
      this.subjectKeywordEditForm.id = rowData.id;
      this.subjectKeywordEditForm.companyId = rowData.companyId;
      this.subjectKeywordEditForm.keyword = rowData.keyword;
    },
    editSubjectKeywordSubmit: function(name) {
      const updateData = {
        id: this.subjectKeywordEditForm.id,
        keyword: this.subjectKeywordEditForm.keyword,
        companyId: this.subjectKeywordEditForm.companyId
      };
      // 添加 编辑关键词
      this.$api.mailbox.createSubjectKeyword(updateData).then(res => {
        setTimeout(() => {
          this.$refs[name].resetFields();
          this.loadingEdit = false;
          this.$nextTick(() => {
            this.loadingEdit = true;
          });
          this.$Message.success(this.$t("common.editSuccess"));
          tableSubjectKeywordVue.getSubjectKeywordData();
          this.editSubjectKeywordModalVisible = false;
        }, 1000);
      });
    },
    editSubjectKeywordReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
// 自定义列删除组件  如果当前行有id显示删除按钮
Vue.component("subjectkeyword-button-group", {
  template: `<span>
      <Button id="edit" @click.stop.prevent="editRow(rowData,index)"
              v-hasPermission="['configurationManagement:monitorMailboxConfiguration:keyword_log']"
              style="color: #fff;background-color: #2db7f5;border-color: #2db7f5;padding: 1px 7px 2px;font-size: 12px;border-radius: 3px;height: 23px;border: none;outline: none;"
      >{{ $t('common.edit') }}</Button>
      &nbsp;
      <Button id="delete" @click.stop.prevent="deleteRow(rowData,index)"
              style="color: #fff;background-color: #ed4014;border-color: #ed4014;padding: 1px 7px 2px;font-size: 12px;border-radius: 3px;height: 23px;border: none;outline: none;"
      >{{ $t('common.del') }}</Button></span>`,
  props: {
    rowData: {
      type: Object
    },
    field: {
      type: String
    },
    index: {
      type: Number
    }
  },
  methods: {
    deleteRow() {
      // 删除
      let params = { type: "delete", index: this.index, rowData: this.rowData };
      this.$emit("on-custom-comp", params);
    },
    editRow() {
      // 编辑
      let params = { type: "edit", index: this.index, rowData: this.rowData };
      this.$emit(`on-custom-comp`, params);
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/TableSubjectKeyword.vue